export const getSimplifiedColorCode = (color) => color ? color.slice(1) : '';
